import { useParams } from "react-router-dom";
import ReportTable from "@/screens/Reports/report-table";

const AppReports = () => {
  const { id } = useParams();
  return <ReportTable params={{ pid: id }} />;
};

export default AppReports;
